import React, { memo } from 'react';
import { useTranslation } from "react-i18next";
import { EXTRA_TEXT_QUESTIONS } from '../constants';

const QuestionTitle = memo(({ title, plotLanguage, name }) => {
    const { t } = useTranslation();
    
    const showExtraText = EXTRA_TEXT_QUESTIONS.includes(name);
    
    // Get the available languages from the title object
    const titleKeys = typeof title === 'object' ? Object.keys(title) : [];
    
    // Map 'en' to 'default' since English content uses 'default' key
    const languageKey = plotLanguage === 'en' ? 'default' : plotLanguage;
    
    // Try to find the best title in this order:
    // 1. Selected language
    // 2. English version (stored as 'default')
    // 3. Lithuanian version
    // 4. Any available language
    // 5. Original title (if not an object)
    const displayTitle = typeof title === 'object' 
        ? title[languageKey] || 
          title['default'] || 
          title['lt'] || 
          (titleKeys.length > 0 ? title[titleKeys[0]] : '') || 
          title
        : title;
    
    return (
        <div 
            className="question-title"
            role="heading" 
            aria-level="3"
        >
            <span className="title-text">
                {displayTitle}
                {showExtraText && (
                    <span 
                        className="diskriminacijaTextPrieKlausimo"
                        aria-hidden="true" 
                    />
                )}
            </span>
        </div>
    );
});

QuestionTitle.displayName = 'QuestionTitle';

export default QuestionTitle;
